module.exports = __webpack_public_path__ + "img/icon-close.b2965570.svg";